import React from 'react';
import { Box, Typography, Button, Rating } from '@mui/material';
import { useTheme } from '../../../ThemeContext';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DirectionsIcon from '@mui/icons-material/Directions';

const ContactUs = () => {
  const { isDarkMode } = useTheme();

  const bgPrimary = isDarkMode ? '#050a14' : '#f8fafc';
  const cardBg = isDarkMode ? '#131b2f' : '#ffffff';
  const textPrimary = isDarkMode ? '#ffffff' : '#0d1530';
  const textSecondary = isDarkMode ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)';

  return (
    <Box sx={{ background: bgPrimary, pb: { xs: 8, md: 12 }, px: { xs: 2, md: 6 } }}>
      <Box sx={{ position: 'relative', width: '100%', height: { xs: 500, md: 600 }, borderRadius: '24px', overflow: 'hidden', boxShadow: isDarkMode ? '0 16px 48px rgba(0,0,0,0.5)' : '0 16px 48px rgba(7, 164, 245,0.1)' }}>
        
        {/* Google Map */}
        <iframe
          src="https://maps.google.com/maps?q=12.9481806,77.5214001&t=&z=17&ie=UTF8&iwloc=&output=embed"
          width="100%"
          height="100%"
          style={{ 
            border: 0, 
            filter: isDarkMode ? 'invert(90%) hue-rotate(180deg) brightness(95%) contrast(85%)' : 'none',
            transition: 'filter 0.3s ease'
          }}
          allowFullScreen=""
          loading="lazy"
          title="Location Map"
        ></iframe>

        {/* Floating Address Card */}
        <Box
          sx={{
            position: 'absolute',
            top: { xs: 'auto', md: '50%' },
            bottom: { xs: 20, md: 'auto' },
            left: { xs: '50%', md: 40 },
            transform: { xs: 'translateX(-50%)', md: 'translateY(-50%)' },
            background: cardBg,
            borderRadius: '20px',
            p: 3,
            width: '90%',
            maxWidth: 320,
            boxShadow: '0 24px 48px rgba(0,0,0,0.2)',
            zIndex: 10,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 1.5 }}>
            <Typography sx={{ fontWeight: 800, color: textPrimary, fontSize: '1.1rem' }}>
              Film-hook Mediaapps Pvt Ltd
            </Typography>
            <Box sx={{ width: 32, height: 32, borderRadius: '50%', background: '#e0f2fe', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#07a4f5', flexShrink: 0 }}>
              <LocationOnIcon fontSize="small" />
            </Box>
          </Box>
          
          <Typography sx={{ color: textSecondary, fontSize: '0.85rem', lineHeight: 1.6, mb: 2 }}>
            1st Floor, 1A, MAIN ROAD, 3, Mysore Rd, near Indian Oil Petrol Pump, Chaitra Layout, Nayandahalli, Bengaluru, Karnataka 560039
          </Typography>
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
            <Typography sx={{ fontWeight: 800, color: textPrimary, fontSize: '0.9rem' }}>5.0</Typography>
            <Rating value={5} readOnly size="small" />
            <Typography sx={{ color: textSecondary, fontSize: '0.8rem' }}>(16)</Typography>
          </Box>
          
          <Button
            variant="contained"
            startIcon={<DirectionsIcon />}
            component="a"
            href="https://www.google.com/maps/place/1st+Floor,+'A,+Film-hook+Mediaapps+Pvt+Ltd,+MAIN+ROAD,+3,+Mysore+Rd,+near+Indian+Oil+Chetti+Petrol+Bunk,+North+Layout,+Metro+Lay+Out,+Nayanda+Halli,+Bengaluru,+Karnataka+560039/data=!4m2!3m1!1s0x3bae3fceae4e70bb:0x249e90041ab20e63!18m1!1e1?utm_source=mstt_1&entry=gps&coh=192189&g_ep=CAESBzI2LjMzLjQYACCenQoqvQEsOTQyNjc3MjcsOTQyOTIxOTUsOTQyOTk1MzIsMTAwNzk2NDk4LDEwMDc5Nzc2MSwxMDA4MjY0NzksMTAwNzk2NTM1LDk0MjgwNTc2LDk0MjA3Mzk0LDk0MjA3NTA2LDk0MjA4NTA2LDk0MjE4NjUzLDk0MjI5ODM5LDk0Mjc1MTY4LDk0Mjc5NjE5LDEwMDgxNTY0MCwxMDA4MjUwMjUsMTAwODIwMjM3LDEwMDgyMjQ4OSwxMDA4MDQ5NzVCAklO&skid=5397eab8-9744-4576-b669-c3208527fbf9&g_st=ac"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              background: '#07a4f5',
              color: 'white',
              fontWeight: 700,
              borderRadius: '24px',
              px: 3,
              textTransform: 'none',
              boxShadow: '0 8px 16px rgba(7, 164, 245,0.3)',
              '&:hover': { background: '#068bc2' }
            }}
          >
            Directions
          </Button>
        </Box>
        
      </Box>
    </Box>
  );
};

export default ContactUs;
